export const IMA_CONTAINER_ID = 'ima-container';
